import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/user";

export const AuthController = ({ roles, children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(UserContext);
  if (!state.isLoggedIn) navigate("/giris");
  useEffect(() => {
    if (!roles.some((_role) => state?.role == _role)) {
      navigate("/giris");
    }
  }, [state]);

  return <>{children}</>;
};
